
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});

var $4afefbc89467b28f$exports = {};

(parcelRequire("hzK4Z")).register(new URL("", import.meta.url).toString(), JSON.parse('["hoCa5","confirmation-page.58c980e6.js","avTVb","dev.b584295f.js","7H9zx","Intro.d229ae0e.js","1gxHN","Outro.837860b5.js","fOXwx","EN02.38244805.js","jR1dY","EN03.b44bfc79.js","fygxg","EN04.cb380d08.js","f8QFu","DE02.1d7d3b19.js","f0hvp","DE03.0719494b.js","h8iSh","DE04.1df9e9fc.js","4Bo1q","FR02.99ff3239.js","jaGIj","FR03.7f5c8cc2.js","d5uGg","FR04.1a0f5f9a.js","aZWwn","ES02.4f1e50b0.js","aM7eQ","ES03.fbbce5c6.js","jxXZL","ES04.84636a3c.js","jbpwU","JA02.5eb2b3d3.js","3BL8n","JA03.7a1a4df4.js","gbGhY","JA04.89f590eb.js","iYtLx","PTBR02.55c3ac81.js","knDtL","PTBR03.e39b525a.js","4GGb6","PTBR04.adf70cee.js","guXWA","cs.3a200a92.js","fz3Ye","da.a2e3f461.js","feOlH","de.00834249.js","c1rm4","en_GB.63291800.js","6P0U9","en_ZZ.5701d3dd.js","gDhTz","es.0802d40e.js","jHaab","fi.81e22326.js","8TMIA","fr.7ac8210e.js","hy7Kv","hu.a9f88e90.js","crwcy","it.91b2f8b2.js","7srAX","ja.9d195e03.js","jfbJ7","ko.76c2cdbd.js","d5Go6","nb.bcd07ee7.js","9ftPF","nl.f52c1e35.js","1DonR","pl.950f5d89.js","gJoen","pt_BR.81ae7f63.js","6EPT4","ru.271619c1.js","kZHnc","sv.edbe1fa9.js","jWttu","th.4b915843.js","dvvtb","tr.3d28202d.js","jA7xV","uk.b1a5f64d.js","7t8pD","vi.df61bd89.js","dWIBE","zh_TW.c3a4bb63.js","aedSr","zh.2f902557.js","85MjQ","esm.450df342.js","6nrg1","esm.d37917ef.js","ePOAk","main.011f0167.js","r2LdC","main.fbd53f70.js","fbeYx","main.3b6d45f6.js","bYHFR","main.15a113fe.js","8ZGdl","main.9fd203a8.js","l98x6","cs.cfa1aaa6.js","4hg9C","da.d12ab62b.js","i6Fnk","de.3aac1adc.js","c474k","en.771eabca.js","cjgze","en_GB.03e08509.js","2B72B","es.78f0d480.js","3RoeY","et.04ca78da.js","kzeAs","fi.5f4d0a66.js","7we5e","fr.d3250e8c.js","8Wam8","hu.0f171507.js","428dh","is.8e88f107.js","edNH1","it.ded31338.js","985J5","ja.e39aec4d.js","6Zg5Y","ko.e2e93c0a.js","ca2Zr","nb.45931067.js","jcATS","nl.ecb86b0c.js","g7y8F","pl.7bc2bd4a.js","aoY7J","pt_BR.121c24b0.js","02uCC","pt_PT.bc66817e.js","2ifyE","ro.5a2cc16c.js","8zLAu","ru.d64c5703.js","hbDpd","sk.c4427246.js","hau5x","sv.accc5841.js","hHys4","th.66ee3d8f.js","5ylZp","tr.d9c01863.js","drt9J","uk.01f44c30.js","2sXsS","vi.b15a0389.js","gECUg","zh_TW.d166f923.js","gXDVT","zh.8080ce0f.js","gGYrV","1TAIL.1d0bc234.js","aFjZp","1TOP.a325e3b8.js","93HEw","2TAIL.08ec9328.js","bgHSP","2TOP.2a8a296d.js","jz4Fc","3TAIL.a3adcd9b.js","kdlH7","3TOP.327341dc.js","jJfVo","4TAIL.2e62d2ce.js","fFjTe","4TOP.c2c95f60.js","7XMft","5REFLOOP.6127c8ee.js","iUkan","6LOOP.23630173.js","5CtkU","7OUTRO.73720b8b.js"]'));


//# sourceMappingURL=confirmation-page.runtime.6acebf5b.js.map
